import React from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Grid, TextField } from "@mui/material";

const CustomDatePicker = ({
  label,
  name,
  value,
  onChange,
  maxDate,
  required,
  error,
  helperText,
  minDate,
  disabled = false,
  gridSize = 4,
  gridSx,
}) => {
  return (
    <Grid item xs={gridSize} sx={gridSx}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
        <DatePicker
          label={label}
          name={name}
          value={dayjs(value)}
          onChange={(newValue) => {
            onChange(newValue.format("YYYY-MM-DD"));
          }}
          minDate={minDate ? dayjs(minDate) : undefined}
          format="DD/MM/YYYY"
          maxDate={maxDate}
          sx={{ width: "100%" }}
          required={required}
          disabled={disabled}
          slotProps={{
            textField: {
              fullWidth: true,
              error: error,
              helperText: helperText,
            },
          }}
          textField={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
    </Grid>
  );
};

export default CustomDatePicker;
